"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActorOptimizeQueryOperationRewriteMove = void 0;
const bus_optimize_query_operation_1 = require("@comunica/bus-optimize-query-operation");
const context_entries_1 = require("@comunica/context-entries");
const core_1 = require("@comunica/core");
const utils_algebra_1 = require("@comunica/utils-algebra");
/**
 * A comunica Rewrite Move Optimize Query Operation Actor.
 */
class ActorOptimizeQueryOperationRewriteMove extends bus_optimize_query_operation_1.ActorOptimizeQueryOperation {
    constructor(args) {
        super(args);
    }
    async test(_action) {
        return (0, core_1.passTestVoid)();
    }
    async run(action) {
        const dataFactory = action.context.getSafe(context_entries_1.KeysInitQuery.dataFactory);
        const factory = new utils_algebra_1.AlgebraFactory(dataFactory);
        const operation = utils_algebra_1.algebraUtils.mapOperation(action.operation, { [utils_algebra_1.Algebra.Types.MOVE]: {
                preVisitor: () => ({ continue: false }),
                transform: (operationOriginal) => {
                    // No-op if source === destination
                    if ((typeof operationOriginal.destination === 'string' && typeof operationOriginal.source === 'string' &&
                        operationOriginal.destination === operationOriginal.source) ||
                        (typeof operationOriginal.destination !== 'string' && typeof operationOriginal.source !== 'string' &&
                            operationOriginal.destination.equals(operationOriginal.source))) {
                        return factory.createCompositeUpdate([]);
                    }
                    // MOVE is equivalent to drop destination, add, and drop source
                    const updates = [
                        factory.createDrop(operationOriginal.destination, true),
                        factory.createAdd(operationOriginal.source, operationOriginal.destination, operationOriginal.silent),
                        factory.createDrop(operationOriginal.source),
                    ];
                    return factory.createCompositeUpdate(updates);
                },
            } });
        return { operation, context: action.context };
    }
}
exports.ActorOptimizeQueryOperationRewriteMove = ActorOptimizeQueryOperationRewriteMove;
//# sourceMappingURL=ActorOptimizeQueryOperationRewriteMove.js.map